import { render } from "./TvmColorSwatches.vue?vue&type=template&id=0a447b0c&scoped=true"
import script from "./TvmColorSwatches.vue?vue&type=script&lang=js"
export * from "./TvmColorSwatches.vue?vue&type=script&lang=js"

import "./TvmColorSwatches.vue?vue&type=style&index=0&id=0a447b0c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a447b0c"],['__file',"src/components/ChatWidget/TvmColorSwatches/TvmColorSwatches.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a447b0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a447b0c', __exports__)) {
    api.reload('0a447b0c', __exports__)
  }
  
  module.hot.accept("./TvmColorSwatches.vue?vue&type=template&id=0a447b0c&scoped=true", () => {
    api.rerender('0a447b0c', render)
  })

}


export default __exports__